// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Y_lUI","rightAdornment":"Header_rightAdornment__xz6nr"};